module.exports = __webpack_public_path__ + "img/关于我们1.81f939ae.png";